module.exports = __webpack_public_path__ + "media/images/symbols/new-logo-horizontal-c76aa057ecddb0f979f59bc401797146.svg";